import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import { ContactCTA } from "@/pages/Home";
import { ArrowLeft, ExternalLink } from "lucide-react";

export default function PortfolioDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/portfolio/${slug}`).then((r) => setItem(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="container-wv flex min-h-[70vh] flex-col items-center justify-center text-center">
        <h1 className="font-heading text-3xl font-semibold text-white">Project not found</h1>
        <Link to="/portfolio" className="btn-primary mt-6">Back to portfolio</Link>
      </div>
    );
  }
  if (!item) return <div className="min-h-[70vh]" />;

  return (
    <>
      <SEO title={item.title} description={item.description} image={item.image} path={`/portfolio/${slug}`} />
      <PageHero
        overline={item.category}
        title={item.title}
        subtitle={item.description}
        crumbs={[{ label: "Portfolio", to: "/portfolio" }, { label: item.title }]}
      />
      <section className="py-20 lg:py-28">
        <div className="container-wv">
          <Reveal className="overflow-hidden rounded-3xl border border-white/10">
            <img src={item.image} alt={item.title} className="w-full object-cover" />
          </Reveal>
          <div className="mt-12 grid gap-10 lg:grid-cols-[1fr_320px]">
            <Reveal>
              <h2 className="font-heading text-2xl font-semibold text-white">About this project</h2>
              <p className="mt-4 text-base leading-relaxed text-slate-400">{item.description}</p>
              <p className="mt-4 text-base leading-relaxed text-slate-400">
                We partnered with {item.client} to deliver a solution engineered for performance, scale and measurable business impact — combining thoughtful design with robust engineering.
              </p>
            </Reveal>
            <Reveal delay={0.1} className="h-fit rounded-3xl border border-white/10 bg-white/[0.03] p-6">
              <dl className="space-y-4 text-sm">
                <div><dt className="text-slate-500">Client</dt><dd className="mt-1 font-medium text-white">{item.client}</dd></div>
                <div><dt className="text-slate-500">Category</dt><dd className="mt-1 font-medium text-white">{item.category}</dd></div>
                <div><dt className="text-slate-500">Stack</dt><dd className="mt-1 flex flex-wrap gap-2">{item.tags?.map((t) => <span key={t} className="rounded-full bg-vantage/10 px-2.5 py-1 text-xs text-vantage">{t}</span>)}</dd></div>
              </dl>
              {item.url && item.url !== "#" && (
                <a href={item.url} target="_blank" rel="noopener noreferrer" className="btn-primary mt-6 w-full">
                  Visit site <ExternalLink className="h-4 w-4" />
                </a>
              )}
            </Reveal>
          </div>
          <div className="mt-16">
            <Link to="/portfolio" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white">
              <ArrowLeft className="h-4 w-4" /> All projects
            </Link>
          </div>
        </div>
      </section>
      <ContactCTA />
    </>
  );
}
